import React__default from 'react';
import { CartContext } from '../../context/CartContext.esm.js';
import '../../context/CartSettingsContext.esm.js';
import 'tslib';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../constants/api.esm.js';
import ShoppingCartIcon from '../../static/images/svg/ShoppingCartIcon.esm.js';
import styles from './MiniCart.module.esm.js';

var MiniCartIcon = function () {
    var cart = React__default.useContext(CartContext).cart;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ShoppingCartIcon, null),
        (cart === null || cart === void 0 ? void 0 : cart.orderGroups) && React__default.createElement("span", { className: styles.badge }, cart.orderGroups.length)));
};

export { MiniCartIcon as default };
//# sourceMappingURL=MiniCartIcon.esm.js.map
